<template>
  <v-container>
    <v-data-table
      :headers="calc_headers"
      :items="calc_items"
      class="elevation-1"
      :loading="calcLoading"
      loading-text="Загружаю данные"
      item-key="RCP_UUID"
      show-select
      single-select
      :search="calcSearch"
      :value="value"
      @input="setValue"
      locale="ru-RU"
      dense
    >
      <template v-slot:top>
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Рецептуры</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="calcSearch"
            append-icon="mdi-magnify"
            label="Искать"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:no-data>
        Нет данных
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { CALC_GET_LIST, CALC_FREE_LIST } from '@/store/actions/calculations'
import { UI_SNACKBAR } from '@/store/actions/ui'
export default {
  props: {
    value: Array,
    default: function () {
      return []
    },
    conf: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  name: 'calculationsTable',
  components: {
  },
  data () {
    return {
      calc_headers: [
        { text: 'Мнемоника', value: 'RCP_NAME' },
        { text: 'Дата создания', align: 'start', value: 'CR_DATE' }
      ],
      calcLoading: false,
      calcSearch: '',
      selectedCalc: []
    }
  },
  watch: {
    conf (val) {
      if (val && val.ULF_UUID) {
        this.getList()
      } else {
        this.$store.commit(CALC_FREE_LIST)
      }
    }
  },
  computed: {
    calc_items: {
      get: function () {
        const items = this.$store.getters.getCurrentCalculationsList
        return items
      }
    }
  },
  mounted: function () {
    if (this.calc_items.length === 0) {
      this.getList()
    }
  },
  methods: {
    setValue (val) {
      this.$emit('input', val)
    },
    getList () {
      console.log('Getting calculations list for conf ', this.conf)
      this.calcLoading = true
      this.$store.dispatch(CALC_GET_LIST, { ULF_UUID: this.conf.ULF_UUID })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка расчётов: \n ${err}` })
        })
        .finally(() => {
          this.calcLoading = false
        })
    }
  }
}
</script>
